<div class="add-tenant-relationship-modal">
    <div class="header">
      <div class="title">
        <span *ngIf="action === 'Add'">Add Relationship</span>
        <span *ngIf="action === 'View'">View Relationship</span>
      </div>
      <div>
        <span [bpIcon]="closeIcon" (click)="onCloseModal()"></span>
      </div>
    </div>

    <div *ngIf="action=='Add'">
      <mat-dialog-content>
        <div class="add-mode-grid tenant-details">
              <div class="grid-header">
                <app-filter-grid
                  [searchPlaceholder]="'Search by Customer Name, Tenant Name or Tenant ID'"
                  (changeFilter)="onChangeFilter($event)">
                </app-filter-grid>
              </div>
            
              <bpe-grid
                [isMultipleSelection]="true"
                [isSelectable]="true"
                [showViewMore]="false"
                [columnDefs]="addColumnDefs"
                [data]="tenantRelations"
                [disabled]="false"
                [pagination]="pagination"
                selectionKey="ngCarrierClientInstanceIDRelation"
                (onPageChange)="onPageChange($event)"
                (onSelectedKeysChange)="onSelectedKeysChange($event)"
                (onSort)="onSortChange($event)">
              </bpe-grid>
        </div>
        <div class="btn-container buttons-right"
          *ngIf="true">
          <button type="button" class="secondary md" (click)="onCloseModal()">Cancel</button>
          <button [disabled]="false" type="submit" class="primary md" (click)="onSave()">Save</button>
        </div>
      </mat-dialog-content>
    </div>

    <div *ngIf="action=='View'">

      <mat-dialog-content>
        <div class="tenant-details">
              <div class="grid-header">
                <app-filter-grid
                  [searchPlaceholder]="'Search by Customer Name, Tenant Name or Tenant ID'"
                  (changeFilter)="onChangeFilter($event)">
                </app-filter-grid>
                <div class="header__actions">
                  <span (click)="showActivity()" class="activity-icon" [bpMatIcon]="activityIcon"></span>
                </div>
              </div>

              <bpe-grid
                [showViewMore]="false"
                [columnDefs]="editColumnDefs"
                [data]="tenantRelations"
                [disabled]="false"
                [pagination]="pagination"
                [optionsTmpl]="optionsTmpl"
                (onPageChange)="onPageChange($event)"                
                (onSort)="onSortChange($event)">
              </bpe-grid>
        </div>
        <div class="btn-container buttons-right"
          *ngIf="true">
          <button type="button" class="secondary md" (click)="onCloseModal()">Cancel</button>
        </div>
      </mat-dialog-content>
    </div>
  
    
</div>

<ng-template #optionsTmpl let-item="item">
  <button mat-menu-item class="item-btn" (click)="openRemoveConfirmation(item)">
    <span>Remove</span>
  </button>
</ng-template>
